import { render, staticRenderFns } from "./bottom_h5_lang.vue?vue&type=template&id=0a282e5f&scoped=true"
import script from "./bottom_h5_lang.vue?vue&type=script&lang=js"
export * from "./bottom_h5_lang.vue?vue&type=script&lang=js"
import style0 from "./bottom_h5_lang.vue?vue&type=style&index=0&id=0a282e5f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a282e5f",
  null
  
)

export default component.exports